import {ReactNode} from "react";

/** Convenience type for implementing lazy children */
export type LazyJsx = ReactNode | (() => ReactNode);

/** Renders lazy children */
export const renderLazy = (jsx: LazyJsx): ReactNode =>
    //eslint-disable-next-line @typescript-eslint/no-unsafe-return
    typeof jsx === "function" ? jsx() : jsx;
